import { HERO_IMG, HERO_MAIN, HERO_MINI_1, HERO_MINI_2 } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute inset-0 paper-grain opacity-60" />
      <div className="mx-auto max-w-[1240px] px-4 py-8 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* text column */}
          <div className="animate-rise lg:col-span-7">
            <div className="flex flex-wrap items-center gap-2">
              <span className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-600 px-3 py-1 text-[13px] font-bold text-background-50">
                <i className="ri-fire-fill w-4 h-4 flex items-center justify-center" />
                {HERO_MAIN.tag}
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-[13px] font-semibold text-accent-900">
                <i className="ri-flag-2-line w-4 h-4 flex items-center justify-center" />
                {HERO_MAIN.kicker}
              </span>
              <span className="flex items-center gap-1 text-[13px] text-foreground-500">
                <span className="relative flex h-2 w-2">
                  <span className="animate-pulse-dot absolute inline-flex h-full w-full rounded-full bg-primary-500" />
                </span>
                全网正在热议
              </span>
            </div>

            <h2 className="mt-5 font-heading text-[26px] font-black leading-snug text-foreground-950 md:text-[34px] md:leading-tight">
              {HERO_MAIN.title}
            </h2>

            <p className="mt-4 max-w-2xl text-[15px] leading-7 text-foreground-700">{HERO_MAIN.excerpt}</p>

            <div className="mt-5 flex flex-wrap items-center gap-2 text-[13px]">
              {HERO_MAIN.meta.map((m) => (
                <span
                  key={m}
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-100 px-2.5 py-1 text-secondary-900"
                >
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
                  {m}
                </span>
              ))}
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <a
                href="#deep"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-[15px] font-bold text-background-50 transition-colors hover:bg-primary-700"
              >
                进入深扒
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
              <a
                href="#report"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-5 py-2.5 text-[15px] font-semibold text-secondary-800 transition-colors hover:border-secondary-400 hover:bg-secondary-50"
              >
                <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center" />
                加入吃瓜讨论
              </a>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-dashed border-background-300 pt-4 text-[13px] text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                本条已 238 万次围观
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-heart-3-line w-4 h-4 flex items-center justify-center" />
                6.2 万 赞成有瓜
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-share-forward-line w-4 h-4 flex items-center justify-center" />
                转发 3.1 万
              </span>
            </div>
          </div>

          {/* image column */}
          <div className="animate-rise lg:col-span-5">
            <div className="relative overflow-hidden rounded-lg">
              <img
                src={HERO_IMG}
                alt="海角天崖顶流旧账深扒人物剪影"
                className="h-[360px] w-full object-cover object-top md:h-[440px]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent" />
              <div className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-primary-600/90 px-2.5 py-1 text-[12px] font-bold text-background-50 backdrop-blur">
                <i className="ri-radar-line w-4 h-4 flex items-center justify-center" />
                热度实时
              </div>
              <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between gap-3">
                <p className="font-heading text-[15px] font-bold leading-snug text-background-50">海角天崖·今日焦点人物</p>
                <span className="whitespace-nowrap rounded-md bg-background-50/15 px-2 py-0.5 text-[12px] text-background-50 backdrop-blur">
                  238 万
                </span>
              </div>
            </div>

            {/* two mini gallery rows */}
            <div className="mt-3 grid grid-cols-2 gap-3">
              {HERO_MAIN.gallery.map((g, i) => {
                const src = i === 0 ? HERO_MINI_1 : HERO_MINI_2;
                return (
                  <a href="#feed" key={g.title} className="group overflow-hidden rounded-lg bg-background-100">
                    <div className="relative overflow-hidden">
                      <img
                        src={src}
                        alt={g.title}
                        className="h-[118px] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent" />
                      <span className="absolute bottom-2 left-2 rounded bg-background-50/15 px-1.5 py-0.5 text-[11px] text-background-50 backdrop-blur">
                        {g.reads} 阅读
                      </span>
                    </div>
                    <div className="flex items-center justify-between gap-2 px-2.5 py-2">
                      <p className="line-clamp-2 text-[13px] font-semibold leading-snug text-foreground-900">{g.title}</p>
                      <span className="whitespace-nowrap text-[11px] text-foreground-500">{g.time}</span>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}